<template>
    <div class="form-container">
        <div class="table-style table-style--default">
            <!-- 개발자확인요청: 영문사이트라서 이름 field 하나만 있었는데 First Name, Last Name으로 나뉘었습니다. -->
            <myinfo-modify-row pointer label="성">
                <v-text-field v-model="form.meta.firstName" type="text" placeholder="성을 입력하세요." outlined persistent-placeholder hide-details class="w-100 mw-lg-600px" />
            </myinfo-modify-row>
            <myinfo-modify-row pointer label="이름">
                <v-text-field v-model="form.meta.lastName" type="text" placeholder="이름을 입력하세요." outlined persistent-placeholder hide-details class="w-100 mw-lg-600px" />
            </myinfo-modify-row>
            <myinfo-modify-row pointer label="이메일">
                <v-row class="row--small" align="center">
                    <v-col>
                        <v-text-field v-model="form.meta.email1" type="text" name="email1" outlined hide-details class="w-100"></v-text-field>
                    </v-col>
                    <v-col cols="auto">@</v-col>
                    <v-col>
                        <v-text-field v-model="form.meta.email2" type="text" name="email2" outlined hide-details class="w-100"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="auto">
                        <v-select v-model="form.meta.email3" :items="[{ text: '이메일을 직접 입력하세요.', value: null }, 'gmail.com', 'naver.com', 'daum.net']" @change="form.meta.email2 = form.meta.email3" outlined hide-details class="w-100 mw-sm-280px" />
                    </v-col>
                </v-row>
            </myinfo-modify-row>
            <!-- 개발자확인요청: 아래 3개 v-model 임의로 입력했습니다 -->
            <myinfo-modify-row pointer label="전화번호">
                <v-text-field v-model="form.meta.phone" type="text" placeholder="전화번호를 입력하세요." outlined persistent-placeholder hide-details class="w-100" />
            </myinfo-modify-row>
            <myinfo-modify-row pointer label="문의유형">
                <v-select v-model="form.meta.inquiry" :items="inquiryItems" type="text" placeholder="문의유형을 선택하세요." outlined persistent-placeholder hide-details class="w-100 mw-lg-600px" />
            </myinfo-modify-row>
            <myinfo-modify-row pointer label="내용">
                <v-textarea v-model="form.meta.message" type="text" placeholder="내용을 입력하세요." outlined persistent-placeholder hide-details class="w-100" />
            </myinfo-modify-row>
        </div>

        <!-- 하단버튼 -->
        <div class="mt-30 mt-md-60 mt-lg-90 text-center">
            <v-btn x-large tile color="primary" class="w-100 mw-240px font-weight-bold" @click="$emit('save')">제출하기</v-btn>
        </div>
    </div>
</template>

<script>
import ImagesInput from "@/components/console/dumb/images-input.vue";
import BidsItemImgs from "@/components/client/ko/mypage/bids-item-imgs.vue";
import MyinfoModifyRow from "@/components/client/ko/mypage/myinfo-modify-row.vue";

import api from "@/api";

export default {
    components: {
        ImagesInput,
        BidsItemImgs,
        MyinfoModifyRow,
    },
    props: {
        value: { type: Object, default: null },
    },
    data() {
        return {
            work: null,
            form: this.$props.value,
            inquiryItems: [
                { text: "Analyzer System Pakage", value: "Analyzer System Pakage" },
                { text: "Corrosion Monitoring System", value: "Corrosion Monitoring System" },
                { text: "Partnership & PQ", value: "Partnership & PQ" },
                { text: "CEMS / AQMS", value: "CEMS / AQMS" },
            ],
        };
    },
    computed: {
        _work() {
            return this.$route.query._work;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            // const { _work: _id } = this;
            // const { work } = await api.v1.auction.works.get({ _id });
            // this.work = work;
        },
    },
    watch: {
        value() {
            this.board = this.value;
        },

        "form.writer.email"() {
            this.$emit("input", this.form);
        },
        "form.writer.email1"() {
            this.$set(this.form.writer, "email", this.form.writer.email1 && this.form.writer.email2 ? `${this.form.writer.email1}@${this.form.writer.email2}` : null);
        },
        "form.writer.email2"() {
            this.$set(this.form.writer, "email", this.form.writer.email1 && this.form.writer.email2 ? `${this.form.writer.email1}@${this.form.writer.email2}` : null);
        },

        "form.writer.phone"() {
            this.$emit("input", this.form);
        },
        "form.writer.phone1"() {
            this.$set(this.form.writer, "phone", this.form.writer.phone1 && this.form.writer.phone2 && this.form.writer.phone3 ? `${this.form.writer.phone1}-${this.form.writer.phone2}-${this.form.writer.phone3}` : null);
        },
        "form.writer.phone2"() {
            this.$set(this.form.writer, "phone", this.form.writer.phone1 && this.form.writer.phone2 && this.form.writer.phone3 ? `${this.form.writer.phone1}-${this.form.writer.phone2}-${this.form.writer.phone3}` : null);
        },
        "form.writer.phone3"() {
            this.$set(this.form.writer, "phone", this.form.writer.phone1 && this.form.writer.phone2 && this.form.writer.phone3 ? `${this.form.writer.phone1}-${this.form.writer.phone2}-${this.form.writer.phone3}` : null);
        },

        "form.meta.email"() {
            this.$emit("input", this.form);
        },
        "form.meta.email1"() {
            this.$set(this.form.meta, "email", this.form.meta.email1 && this.form.meta.email2 ? `${this.form.meta.email1}@${this.form.meta.email2}` : null);
        },
        "form.meta.email2"() {
            this.$set(this.form.meta, "email", this.form.meta.email1 && this.form.meta.email2 ? `${this.form.meta.email1}@${this.form.meta.email2}` : null);
        },

        "form.meta.phone"() {
            this.$emit("input", this.form);
        },
        "form.meta.phone1"() {
            this.$set(this.form.meta, "phone", this.form.meta.phone1 && this.form.meta.phone2 && this.form.meta.phone3 ? `${this.form.meta.phone1}-${this.form.meta.phone2}-${this.form.meta.phone3}` : null);
        },
        "form.meta.phone2"() {
            this.$set(this.form.meta, "phone", this.form.meta.phone1 && this.form.meta.phone2 && this.form.meta.phone3 ? `${this.form.meta.phone1}-${this.form.meta.phone2}-${this.form.meta.phone3}` : null);
        },
        "form.meta.phone3"() {
            this.$set(this.form.meta, "phone", this.form.meta.phone1 && this.form.meta.phone2 && this.form.meta.phone3 ? `${this.form.meta.phone1}-${this.form.meta.phone2}-${this.form.meta.phone3}` : null);
        },
    },
};
</script>
